import pkg from '../package.json';

export const NAMESPACE                   = 'vocento';
export const PROMISES_PROPERTY           = '__PROMISES__';
export const DEFAULT_TIMEOUT             = 2000;
export const VOCUSER_COOKIE              = 'voc_uid';
export const PAYWALL_COOKIE              = 'voc_paywall';
export const SHOW_LOGS                   = document.location.search.indexOf('vam_debug=1') > -1 || document.location.search.indexOf('gdp_debug=1') > -1;
export const DEFAULT_LOG_TEMPLATE        = '[Ads Manager]';
export const CONFIG_NAMESPACE            = 'vocento.config.vam';
export const EDITIONS_NAMESPACE          = 'vocento.site.editions';
export const GPT_ID_VOCENTO              = '4900';
export const GPT_READY                   = 'vam:gpt:ready';
export const GPT_TIMEOUT                 = 2000;
export const TIMEOUT_POSICIONES_ESTANDAR = 3000;
export const ALTOS_MINIMOS_DISPOSITIVOS  = {
  mobile:  0,
  tablet:  200,
  desktop: 300
};
export const POSITION_FLUID              = "'fluid'";
export const SLOT_RENDERED               = 'vam:slotrendered';
export const SLOT_EMPTY                  = 'vam:isempty';
export const SLOT_VIEWABLE               = 'vam:viewable';
export const SLOT_INACTIVE               = 'vam:inactive';
export const DEFAULTS                    = {
  hideNoAds:  true,
  refresh:    false,
  responsive: false
};
export const CAPTURADOR_WS               = '//publi.cmvocento.com/capturador/preview';
export const MCRYPT_KEY                  = 'acsNdl09acs72AEdacsNdl09acs72AEd';
export const VAM_CSS_URL                 = '//netssl.vocento.com/cmvocento/css/vam.css';
export const JSON_GDP2_0                 = 0;
export const JSON_GDP2_1                 = 1;
export const JSON_GDP2_2                 = 2;
export const NOMBRE_FORMATO_JSON         = ['GDP2.0', 'GDP2.1', 'GDP2.2+'];
export const GPT_URL                     = 'www.googletagservices.com/tag/js/gpt.js';

/* header bidding */
export const HEADER_BIDDING_READY        = 'vam:headerbidding:ready';
const ENV_PREFIX_PRE                     = 'pre-';
const ENV_PREFIX_DES                     = 'des-';
export const PREBID_URL                  = (function IIFE() {
  var url, defaultUrl, prefix;

  defaultUrl = 'prebid.js';
  if (document.location.hostname.indexOf('localhost') !== -1) return defaultUrl;

  url = `static.vocento.com/vam/${pkg.version}/${defaultUrl}`;
  prefix = (document.location.hostname.indexOf(ENV_PREFIX_PRE) === 0 ? ENV_PREFIX_PRE : null) ||
    (document.location.hostname.indexOf(ENV_PREFIX_DES) === 0 ? ENV_PREFIX_DES : '');

  return `//${prefix}${url}`;
}());
export const DEFAULT_PREBID_LOAD_TIMEOUT = 7000;
export const AMAZON_URL                  = '//c.amazon-adsystem.com/aax2/apstag.js';
export const DEFAULT_AMAZON_LOAD_TIMEOUT = 7000;
export const AMAZON_CONFIG               = {
  pubID:    '3470',     // Amazon publisher ID
  adServer: 'googletag' // AdServer type that contains apstag line-items
};

/* legacy */
export const OLD_PREFIX                  = 'publi_';
export const NEW_SUFFIX                  = '-id';



// WEBPACK FOOTER //
// ./src/constants.js